import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from 'react-select';
import * as menuCategorieActions from '../../../redux/menuCategories/actions';
import Spin from '../../../components/loading';
import '../styles.scss';
import { filterByKey } from '../../../utils/FilterByKey';
import ShowForPermission from '../../../components/ShowForPermission';
import enums from '../../../enums';

class AddMenuCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      title: '',
      displayOrder: '',
      loaded: false,
      printers: [],
    };
  }

  componentDidMount() {
    this.props.fetchPrinters().then(response => {
      if (this.props.menuCategoryId) {
        this.props
          .fetchMenuCategoryById(this.props.menuCategoryId)
          .then(details => {
            const printers = filterByKey(
              response.payload.printers,
              details.payload.printers,
              'id',
              'printerId',
            ).map(item => {
              return {
                value: item.id,
                label: item.title,
              };
            });

            let { title, isActive, displayOrder } = details.payload;

            this.setState({
              title,
              isActive,
              displayOrder,
              printers,
              loaded: true,
            });
          });
      }
    });
  }

  saveNewMenuCategory = () => {
    let { title, displayOrder, isActive, printers } = this.state;

    const printersArray = [];
    printers.map(printer => {
      printersArray.push({ printerId: printer.value });
    });
    let menuCategoryObject = {
      title,
      displayOrder,
      isActive,
      printers: printersArray,
    };
    if (this.props.menuCategoryId) {
      menuCategoryObject.id = this.props.menuCategoryId;
      this.props.updateMenuCategory(menuCategoryObject).then(() => {
        let {
          editMenuCategoryError,
          editMenuCategoryMessage,
          editMenuCategoryFailed,
        } = this.props;
        if (
          editMenuCategoryError == false &&
          editMenuCategoryFailed == false &&
          editMenuCategoryMessage == null
        )
          this.props.closeModal();
      });
    } else {
      this.props
        .insertNewMenuCategory(menuCategoryObject)
        .then(() => this.props.closeModal());
    }
  };

  onSelectPrinters = selectedItems => {
    this.setState(() => ({
      printers: selectedItems,
    }));
  };

  render() {
    let { isActive, title, displayOrder } = this.state;
    let {
      error,
      loading,
      message,
      failed,
      menuCategoryDetailsError,
      menuCategoryDetailsMessage,
      menuCategoryDetailsLoading,
      menuCategoryDetailsFailed,
      editMenuCategoryError,
      editMenuCategoryFailed,
      editMenuCategoryLoading,
      editMenuCategoryMessage,
    } = this.props;
    return (
      <>
        <Modal
          id='financial-transaction-modal'
          size='xl'
          isOpen={this.props.isOpen}
        >
          <ModalHeader>
            <div className='row'>
              <div className='col-11'>{locales('titles.newMenuCategory')}</div>
              <div className='col-1 text-left'>
                <a
                  href='#'
                  className=''
                  onClick={event => {
                    event.preventDefault();
                    this.props.closeModal();
                  }}
                >
                  <i className='fas fa-times'></i>
                </a>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <Spin
              spinning={
                loading || menuCategoryDetailsLoading || editMenuCategoryLoading
              }
            >
              <article>
                {(error ||
                  menuCategoryDetailsError ||
                  editMenuCategoryError) && (
                  <div className='alert alert-danger'>
                    {locales('messages.server.error')}
                  </div>
                )}
                {(failed ||
                  menuCategoryDetailsFailed ||
                  editMenuCategoryFailed) && (
                  <div className='alert alert-danger'>
                    {message ||
                      menuCategoryDetailsMessage ||
                      editMenuCategoryMessage}
                  </div>
                )}
                <div className='col-12'>
                  <div className='col-12 p-0 justify-content-between align-items-center d-flex'>
                    <div className='col-6 justify-content-start d-flex p-0'>
                      <label className='col-1 p-0'>
                        {locales('tables.activated')}
                      </label>
                      <div className='col-11 p-0'>
                        <input
                          type='checkbox'
                          onChange={() =>
                            this.setState({ isActive: !isActive })
                          }
                          checked={isActive}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='my-2 col-12 p-0 justify-content-between align-items-center d-flex'>
                    <div className='col-6 justify-content-start d-flex p-0'>
                      <div className='col-12 p-0 required d-flex'>
                        <label
                          className='rsee-form-label d-flex InsertNewCategoryLabelWidth'
                          htmlFor='title'
                        >
                          {locales('tables.title')}
                        </label>
                        <input
                          type='text'
                          id='title'
                          className='form-control col-8 px-2'
                          placeholder={locales('tables.title')}
                          onChange={event =>
                            this.setState({ title: event.target.value })
                          }
                          value={title}
                        />
                      </div>
                    </div>
                    <div className='col-6 justify-content-start d-flex p-0'>
                      <label
                        className='rsee-form-label d-flex InsertNewCategoryLabelWidthForDisplay'
                        htmlFor='display'
                      >
                        {locales('tables.displayOrder')}
                      </label>
                      <div className='col-8 p-0 px-2'>
                        <input
                          type='text'
                          id='display'
                          className='form-control'
                          placeholder={locales('tables.displayOrder')}
                          onChange={event =>
                            this.setState({ displayOrder: event.target.value })
                          }
                          value={displayOrder}
                        />
                      </div>
                    </div>
                  </div>
                  <ShowForPermission
                    permission={enums.PERMISSIONS.values.VIEW_PRINTERS_LIST}
                  >
                    <div className='my-2 col-10 p-0 justify-content-between align-items-center d-flex'>
                      <div className='col-6 justify-content-start d-flex p-0'>
                        <div className='col-12 p-0 required d-flex'>
                          <label
                            className='rsee-form-label d-flex InsertNewCategoryLabelWidth'
                            htmlFor='title'
                          >
                            {locales('titles.printers')}
                          </label>
                          <Select
                            placeholder={locales('messages.select.printers')}
                            isMulti={true}
                            options={this.props.printersList.map(x => ({
                              value: x.id,
                              label: x.title,
                            }))}
                            className='full-width'
                            onChange={this.onSelectPrinters}
                            value={this.state.printers}
                          />
                        </div>
                      </div>
                    </div>
                  </ShowForPermission>
                </div>
              </article>
            </Spin>
          </ModalBody>
          <ModalFooter>
            <button
              className='btn btn-success'
              onClick={() => this.saveNewMenuCategory()}
            >
              {locales('labels.save')}
            </button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.menuCategoriesReducer.insertNewMenuCategoryLoading,
    failed: state.menuCategoriesReducer.insertNewMenuCategoryFailed,
    error: state.menuCategoriesReducer.insertNewMenuCategoryError,
    message: state.menuCategoriesReducer.insertNewMenuCategoryMessage,

    menuCategoryDetailsLoading:
      state.menuCategoriesReducer.menuCategoryDetailsLoading,
    menuCategoryDetailsFailed:
      state.menuCategoriesReducer.menuCategoryDetailsFailed,
    menuCategoryDetailsMessage:
      state.menuCategoriesReducer.menuCategoryDetailsMessage,
    menuCategoryDetailsError:
      state.menuCategoriesReducer.menuCategoryDetailsError,
    menuCategoryDetails: state.menuCategoriesReducer.menuCategoryDetails,

    editMenuCategoryLoading:
      state.menuCategoriesReducer.editMenuCategoryLoading,
    editMenuCategoryFailed: state.menuCategoriesReducer.editMenuCategoryFailed,
    editMenuCategoryMessage:
      state.menuCategoriesReducer.editMenuCategoryMessage,
    editMenuCategoryError: state.menuCategoriesReducer.editMenuCategoryError,
    editMenuCategory: state.menuCategoriesReducer.editMenuCategory,

    fetchPrintersLoading: state.menuCategoriesReducer.fetchPrintersLoading,
    fetchPrintersFailed: state.menuCategoriesReducer.fetchPrintersFailed,
    fetchPrintersError: state.menuCategoriesReducer.fetchPrintersError,
    fetchPrintersMessage: state.menuCategoriesReducer.fetchPrintersMessage,
    printersList: state.menuCategoriesReducer.printersList,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchMenuCategoryById: id =>
      dispatch(menuCategorieActions.fetchMenuCategoryById(id)),
    updateMenuCategory: categoryObject =>
      dispatch(menuCategorieActions.updateMenuCategory(categoryObject)),
    insertNewMenuCategory: additionObject =>
      dispatch(menuCategorieActions.insertNewMenuCategory(additionObject)),
    fetchPrinters: () => dispatch(menuCategorieActions.fetchPrinters()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddMenuCategory);
